import React from 'react';

export const EquipmentContext = React.createContext('equipment');
